module.exports = __webpack_public_path__ + "static/media/Brusher-Regular.fab42fc0.ttf";